import React, { useEffect, useState, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import "./Header.css";
import logo from "../assets/images/optimized/syd-tcs-logo.png";
import avatarDefault from "../assets/avatar/avatar.png";
import avatar1 from "../assets/avatar/avatar1.png";
import avatar2 from "../assets/avatar/avatar2.png";
import avatar3 from "../assets/avatar/avatar3.png";
import avatar4 from "../assets/avatar/avatar4.png";
import avatar5 from "../assets/avatar/avatar5.png";
import avatar6 from "../assets/avatar/avatar6.png";
import avatar7 from "../assets/avatar/avatar7.png";
import puzzleTile from "../assets/images/optimized/puzzleTile.png";
import matchTile from "../assets/images/optimized/matchTile.png";
import trivia from "../assets/images/optimized/trivia.png";
// import mascot from "../assets/images/optimized/mascot.png";
// import headphones from "../assets/images/headphones.svg";
// import shokzLogo from "../assets/images/optimized/shokz.png";
import { useDrawer } from "../context/DrawerContext";
import { useUser } from "../context/UserContext";
import { firstRewardConfig } from "../data/firstRewardConfig";

import FAQModal from "./FAQModal";
import LeaderboardModal from "./LeaderboardModal";
// Removed static leaderboard data import - now using Firebase data

const avatarMap = {
  1: avatar1,
  2: avatar2,
  3: avatar3,
  4: avatar4,
  5: avatar5,
  6: avatar6,
  7: avatar7,
  8: avatarDefault,
};

const CHALLENGES = [
  {
    name: "PUZZLE",
    img: puzzleTile,
    points: 0,
    totalPoints: 120,
    progress: 0,
    totalProgress: 4,
    alt: "Puzzle",
  },
  {
    name: "MATCH TILE",
    img: matchTile,
    points: 40,
    totalPoints: 80,
    progress: 0,
    totalProgress: 2,
    alt: "Match Tile",
  },
  {
    name: "TRIVIA",
    img: trivia,
    points: 60,
    totalPoints: 120,
    progress: 0,
    totalProgress: 4,
    alt: "Trivia",
  },
];

function TreasureDetailCard({ onBack, treasure }) {
  const handleCopy = () => {
    if (treasure?.code) {
      navigator.clipboard.writeText(treasure.code);
    }
  };
  if (process.env.NODE_ENV === "development") {
    console.log("treasure", treasure);
  }
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minHeight: 0,
        height: "100%",
        padding: "16px",
        marginBottom: 32,
        background: "#e6f4fa", // Light blue background
      }}
    >
      <button
        onClick={onBack}
        style={{
          background: "none",
          border: "none",
          color: "#081F2D",
          fontWeight: 600,
          fontSize: 15,
          marginBottom: 10,
          alignSelf: "flex-start",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
        }}
      >
        <span style={{ fontSize: 18, marginRight: 6 }}>&larr;</span> Go Back
      </button>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div
          style={{
            fontWeight: 700,
            fontSize: 18,
            color: "#081F2D",
            marginBottom: 4,
            display: "flex",
            alignItems: "center",
            gap: 8,
          }}
        >
          <span style={{ fontSize: 22 }}>&#127873;</span> TREASURE
        </div>
      </div>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          marginTop: 8,
        }}
      >
        <div
          style={{
            background: "#fff",
            borderRadius: 18,
            boxShadow: "0px 3.11px 12px 0px #00000030",
            padding: "0",
            width: "100%",
            maxWidth: 340,
            margin: "0 4px",
            textAlign: "center",
            minHeight: 0,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          {/* Card Header */}
          <div
            style={{
              background: "#f8f9fa",
              padding: "16px",
              borderBottom: "1px solid #e9ecef",
            }}
          >
            <div
              style={{
                fontWeight: 800,
                fontSize: 18,
                color: "#081F2D",
                textAlign: "center",
                letterSpacing: 0.5,
              }}
            >
              {treasure?.name || "Treasure"}
            </div>
          </div>

          {/* Card Content */}
          <div style={{ padding: "16px" }}>
            {/* Offer Description */}
            <div
              style={{
                fontWeight: 400,
                fontSize: 14,
                color: "#081F2D",
                marginBottom: 24,
                textAlign: "center",
                lineHeight: 1.4,
              }}
            >
              {treasure?.offer || "Special offer available"}
            </div>

            {/* Redemption Code Section - Only show if code exists and is not NaN */}
            {treasure?.code && treasure.code !== "NaN" ? (
              <div style={{ marginBottom: 24 }}>
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: 11,
                    color: "#081F2D",
                    marginBottom: 8,
                    textAlign: "left",
                    textTransform: "uppercase",
                  }}
                >
                  UNIQUE REDEMPTION CODE
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                  }}
                >
                  <div
                    style={{
                      flex: 1,
                      border: "2px dashed #1693f6",
                      borderRadius: 8,
                      padding: "12px 8px",
                      fontWeight: 600,
                      fontSize: 14,
                      color: "#081F2D",
                      background: "#f7fbfd",
                      letterSpacing: 1,
                      textAlign: "center",
                    }}
                  >
                    {treasure.code}
                  </div>
                  <button
                    onClick={handleCopy}
                    style={{
                      background: "#1693f6",
                      color: "#fff",
                      border: "none",
                      borderRadius: 8,
                      fontWeight: 700,
                      fontSize: 12,
                      padding: "12px 16px",
                      cursor: "pointer",
                      textTransform: "uppercase",
                    }}
                  >
                    COPY
                  </button>
                </div>
              </div>
            ) : null}

            {/* Redemption Instructions - Only show if howToRedeem exists and is not NaN */}
            {/* {treasure?.howToRedeem && treasure.howToRedeem !== "NaN" && ( */}
            <div style={{ marginBottom: 24, textAlign: "left" }}>
              <div
                style={{
                  fontWeight: 700,
                  fontSize: 14,
                  color: "#081F2D",
                  marginBottom: 8,
                }}
              >
                Redemption instructions:
              </div>
              <div
                style={{
                  color: "#081F2D",
                  fontSize: 13,
                  lineHeight: 1.5,
                }}
              >
                {treasure.redeem}
              </div>
            </div>
            {/* )} */}

            {/* Opening Hours - Only show if hours exists and is not NaN */}
            {treasure?.hours && treasure.hours !== "NaN" && (
              <div style={{ marginBottom: 24, textAlign: "left" }}>
                <div
                  style={{
                    fontWeight: 700,
                    fontSize: 14,
                    color: "#081F2D",
                    marginBottom: 8,
                  }}
                >
                  Opening hours
                </div>
                <div
                  style={{
                    color: "#081F2D",
                    fontSize: 13,
                    lineHeight: 1.5,
                  }}
                >
                  {treasure.hours}
                </div>
              </div>
            )}

            {/* Terms and Conditions - Only show if terms exists and is not NaN */}
            {/* {treasure?.terms && treasure.terms !== "NaN" && ( */}
            <div style={{ textAlign: "left" }}>
              <div
                style={{
                  fontWeight: 700,
                  fontSize: 14,
                  color: "#081F2D",
                  marginBottom: 8,
                }}
              >
                Terms and Conditions:
              </div>
              <div
                style={{
                  color: "#081F2D",
                  fontSize: 13,
                  lineHeight: 1.5,
                }}
              >
                {treasure.terms}
              </div>
            </div>
            {/* )} */}
          </div>
        </div>
      </div>
    </div>
  );
}

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === "/home";
  const isFindRoutePage = location.pathname === "/find-my-route";
  const isWayfinderPage = location.pathname === "/wayfinder";
  const { isDrawerOpen, setIsDrawerOpen } = useDrawer();
  const [drawerClosing, setDrawerClosing] = useState(false);
  const [collapse, setCollapse] = useState({
    challenges: true,
    treasure: false,
  });
  const { userData, clearUserData } = useUser();
  const [selectedTreasure, setSelectedTreasure] = useState(null);
  const [showFAQModal, setShowFAQModal] = useState(false);
  const [showLeaderboardModal, setShowLeaderboardModal] = useState(false);
  const [dataMode, setDataMode] = useState("loading");
  const [currentTreasureData, setCurrentTreasureData] = useState([]);

  // Load all treasure data (both race day and race week)
  useEffect(() => {
    const loadAllTreasureData = async () => {
      try {
        // Import both datasets
        const { raceDayData } = await import("../raceDay.js");
        const { raceWeekData } = await import("../raceWeek.js");

        // Combine both datasets
        const allTreasureData = [...raceDayData, ...raceWeekData];
        setCurrentTreasureData(allTreasureData);

        // Set data mode to show we have all data
        setDataMode("all");
      } catch (error) {
        console.error("Failed to load treasure data:", error);
        setDataMode("race-week"); // Default to race week
        setCurrentTreasureData([]); // Empty array as fallback
      }
    };

    loadAllTreasureData();
  }, []);

  const handleEmailClick = () => {
    if (userData.verified === false) {
      // Close drawer first, then navigate to welcome page with OTP state
      handleDrawerClose();
      setTimeout(() => {
        navigate("/welcome", { state: { showOTP: true } });
      }, 300); // Wait for drawer close animation to complete
    }
  };

  // Log navigation state changes (development only)
  useEffect(() => {
    if (process.env.NODE_ENV === "development") {
      console.log("Header - Current location:", location.pathname);
      console.log("Header - Location state:", location.state);
      console.log("Header - Full location object:", location);
    }
  }, [location]);

  const handleHelp = () => {
    // Close drawer first, then show FAQ modal
    handleDrawerClose();
    setTimeout(() => {
      setShowFAQModal(true);
    }, 300); // Wait for drawer close animation to complete
  };

  const handleTrophy = () => {
    setShowLeaderboardModal(true);
  };

  const handleMenu = () => {
    setIsDrawerOpen(true);
    setDrawerClosing(false);
  };

  const handleDrawerClose = () => {
    setDrawerClosing(true);
    setTimeout(() => {
      setIsDrawerOpen(false);
      setDrawerClosing(false);
    }, 300); // match the CSS animation duration
  };

  const handleBack = () => {
    // Define explicit back navigation routes based on current location
    const backRoutes = {
      "/welcome": "/", // From welcome, go to splash/root
      "/hunt": "/welcome", // From hunt tutorial, go back to welcome
      "/home": "/hunt", // From home, go back to hunt tutorial (though this shouldn't show back button)
    };

    const targetRoute = backRoutes[location.pathname];

    if (targetRoute) {
      if (process.env.NODE_ENV === "development") {
        console.log("Navigating to explicit route:", targetRoute);
      }
      navigate(targetRoute, { replace: true });
    } else {
      if (process.env.NODE_ENV === "development") {
        console.log("No explicit route found, trying navigate(-1)");
      }
      // Fallback to navigate(-1) with a check
      const currentPath = location.pathname;
      navigate(-1);

      // Check if navigation actually happened after a short delay
      setTimeout(() => {
        if (window.location.pathname === currentPath) {
          if (process.env.NODE_ENV === "development") {
            console.log("navigate(-1) didn't work, falling back to root");
          }
          navigate("/", { replace: true });
        }
      }, 100);
    }
  };

  const handleChallengeClick = (challenge) => {
    // Only navigate if the challenge has no points (progress is 0)
    if (challenge.progress === 0) {
      let gameType = null;
      switch (challenge.name) {
        case "PUZZLE":
          gameType = "jigsaw";
          break;
        case "MATCH TILE":
          gameType = "flip";
          break;
        case "TRIVIA":
          gameType = "quiz";
          break;
        default:
          if (process.env.NODE_ENV === "development") {
            console.log("Unknown challenge:", challenge.name);
          }
          return;
      }

      // Navigate to home page with game type in state
      navigate("/home", {
        state: {
          selectedGame: gameType,
        },
      });

      // Close the drawer after navigation
      handleDrawerClose();
    }
  };

  const handleCollapse = (section) => {
    setCollapse((prev) => {
      const newState = { ...prev, [section]: !prev[section] };
      if (section === "challenges" && newState.challenges)
        newState.treasure = false;
      if (section === "treasure" && newState.treasure)
        newState.challenges = false;
      return newState;
    });
  };

  const handleSignOut = () => {
    // Implement sign out functionality
    if (process.env.NODE_ENV === "development") {
      console.log("Signing out");
    }

    // Use the proper clearUserData function from UserContext
    clearUserData();

    // Close drawer
    setIsDrawerOpen(false);

    // Navigate to welcome page (clearUserData will handle the redirect)
  };

  // Avatar logic
  const avatarImg =
    userData.avatar && avatarMap[userData.avatar.id]
      ? avatarMap[userData.avatar.id]
      : avatar5;

  // For now, let's unlock some treasures based on user progress
  // In a real app, this would be based on user achievements, location, etc.
  // Prepare treasure data with unlocked status from userData
  const treasures = React.useMemo(() => {
    const treasureList = [];

    // Add first reward if user has collected it
    if (userData?.collectedTreasures?.includes("first-reward")) {
      treasureList.push({
        index: -1, // Special index for first reward
        unlocked: true,
        name: "Lime Bike",
        isFirstReward: true,
      });
    }

    // Add regular treasures
    if (currentTreasureData.length > 0) {
      currentTreasureData.forEach((treasure, i) => {
        treasureList.push({
          index: i,
          unlocked:
            userData?.collectedTreasures?.includes(treasure.id) || false,
          name: treasure.name,
          isFirstReward: false,
        });
      });
    }

    return treasureList;
  }, [currentTreasureData, userData?.collectedTreasures]);

  // Sort unlocked treasures to the start
  const sortedTreasures = useMemo(
    () => [
      ...treasures.filter((t) => t.unlocked),
      ...treasures.filter((t) => !t.unlocked),
    ],
    [treasures]
  );

  return (
    <>
      <header className="app-header">
        <div className="header-logo-container">
          {isHomePage ? (
            <img src={logo} alt="TCS Sydney Marathon" className="header-logo" />
          ) : (
            <button className="back-button" onClick={handleBack}>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15 18L9 12L15 6"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          )}
        </div>
        <div className="header-actions">
          {isHomePage ? (
            <>
              {/* Data mode indicator */}
              {/* {dataMode !== "loading" && (
                <div
                  className="data-mode-indicator"
                  style={{
                    fontSize: "10px",
                    padding: "2px 6px",
                    borderRadius: "4px",
                    backgroundColor:
                      dataMode === "race-day" ? "#ff6b6b" : 
                      dataMode === "race-week" ? "#4ecdc4" : "#9b59b6",
                    color: "white",
                    fontWeight: "600",
                    marginRight: "8px",
                  }}
                                  >
                    {dataMode === "race-day" ? "RACE DAY" : 
                     dataMode === "race-week" ? "RACE WEEK" : "ALL"}
                  </div>
              )} */}
              <button className="icon-button" onClick={handleTrophy}>
                <i className="fas fa-trophy"></i>
              </button>
              <button className="icon-button" onClick={handleMenu}>
                <i className="fas fa-bars"></i>
              </button>
            </>
          ) : null}
          {isHomePage || isFindRoutePage || isWayfinderPage ? null : (
            <button className="help-button" onClick={handleHelp}>
              FAQ <span className="help-icon">?</span>
            </button>
          )}
        </div>
      </header>
      {isDrawerOpen && (
        <div className="drawer-overlay" onClick={handleDrawerClose}>
          <div
            className={`drawer${drawerClosing ? " drawer-closing" : ""}`}
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#e6f4fa",
              display: "flex",
              flexDirection: "column",
              padding: 0,
            }}
          >
            <button className="drawer-close" onClick={handleDrawerClose}>
              &times;
            </button>
            <div
              className="drawer-profile"
              style={{
                padding: "32px 24px 16px 24px",
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <img
                src={avatarImg}
                alt="avatar"
                className="drawer-avatar"
                style={{
                  width: 50,
                  height: 50,
                  borderRadius: "50%",
                  background: "#fff",
                  objectFit: "cover",
                  aspectRatio: 1 / 1,
                }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = avatar5;
                }}
              />
              <div style={{ minWidth: 0 }}>
                <div
                  className="drawer-name"
                  style={{ fontWeight: 700, fontSize: 18, color: "#081F2D" }}
                >
                  {userData.name || "Akash Gaur"}
                </div>
                <div
                  className="drawer-email"
                  onClick={handleEmailClick}
                  style={{
                    color: userData.verified === false ? "#ff4444" : "#6D6D6D",
                    fontWeight: 500,
                    fontSize: 14,
                    wordBreak: "break-all",
                    whiteSpace: "normal",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    cursor: userData.verified === false ? "pointer" : "default",
                    textDecoration:
                      userData.verified === false ? "underline" : "none",
                  }}
                >
                  {userData.email || "alex.johnson@example.com"}
                  {userData.verified === false && (
                    <span
                      style={{
                        marginLeft: "8px",
                        fontSize: "12px",
                        opacity: 0.8,
                      }}
                    >
                      (Guest)
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="drawer-section" style={{ padding: "0 24px" }}>
              {/* Challenges */}
              <div
                className="drawer-list-item"
                onClick={() => handleCollapse("challenges")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 700,
                  fontSize: 16,
                  color: "#0a2a3a",
                  cursor: "pointer",
                  gap: 16,
                  padding: "18px 0",
                }}
              >
                <i className="fas fa-th-large"></i>
                <span>SCORE BOOSTERS</span>
                <span
                  style={{
                    marginLeft: "auto",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    transition: "transform 0.2s",
                  }}
                >
                  {/* <span
                    style={{ fontSize: 14, color: "#1693f6", fontWeight: 600 }}
                  >
                    Total: {userData?.totalBoosterScore || 0}
                  </span> */}
                  <i
                    className={`fas fa-chevron-down${
                      collapse.challenges ? " fa-rotate-180" : ""
                    }`}
                  ></i>
                </span>
              </div>
              <hr
                style={{
                  border: 0,
                  borderTop: "2px solid #081F2D",
                  margin: "0 !important",
                }}
              />
              {collapse.challenges && (
                <div
                  className="drawer-expand-content"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(3, 1fr)",
                    gap: 10,
                    padding: "16px 0 8px 0",
                    background: "#eaf7fc",
                    borderRadius: 18,
                    maxHeight: 420,
                    overflowY: "auto",
                  }}
                >
                  {CHALLENGES.map((challenge) => {
                    const earnedPoints =
                      userData?.challengeScores?.[challenge.name] || 0;
                    const isClickable = earnedPoints === 0;
                    return (
                      <div
                        key={challenge.name}
                        style={{
                          width: "100%",
                          cursor: isClickable ? "pointer" : "default",
                          maxHeight: 106,
                        }}
                        onClick={() => {
                          if (isClickable) {
                            handleChallengeClick(challenge);
                          } else {
                            // Prevent multiple toasts for the same challenge
                            const toastId = `challenge-${challenge.name}`;

                            // Dismiss any existing toasts for this challenge
                            toast.dismiss(toastId);

                            // Clear any existing timeouts to prevent multiple toasts
                            if (
                              window.challengeToastTimeouts &&
                              window.challengeToastTimeouts[toastId]
                            ) {
                              clearTimeout(
                                window.challengeToastTimeouts[toastId]
                              );
                            }

                            // Initialize timeout storage if it doesn't exist
                            if (!window.challengeToastTimeouts) {
                              window.challengeToastTimeouts = {};
                            }

                            // Add small delay to prevent rapid clicking
                            const timeoutId = setTimeout(() => {
                              // Double-check no other toast is showing for this challenge
                              if (
                                !document.querySelector(
                                  `[data-toast-id="${toastId}"]`
                                )
                              ) {
                                toast(
                                  "Booster games can only be played once.",
                                  {
                                    duration: 3000,
                                    id: toastId,
                                    style: {
                                      background: "#0096db",
                                      color: "#fff",
                                      border: "none",
                                      boxShadow: "none",
                                    },
                                  }
                                );
                              }

                              // Clean up timeout reference
                              if (window.challengeToastTimeouts[toastId]) {
                                delete window.challengeToastTimeouts[toastId];
                              }
                            }, 100);

                            // Store timeout reference
                            window.challengeToastTimeouts[toastId] = timeoutId;
                          }
                        }}
                      >
                        {/* <div
                          style={{
                            background: "#fff",
                            fontWeight: 700,
                            fontSize: 10,
                            color: "#081F2D",
                            textAlign: "center",
                            height: "-webkit-fill-available",
                            fontWeight: "bold",
                            width: "100%",
                            borderRadius: 10,
                            padding: "10px 6px",
                            // boxShadow: "0px 3.11px 3.11px 0px #00000040",
                          }}
                        >
                          {challenge.name}
                        </div> */}
                        <div
                          style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                            borderRadius: 10,
                            padding: " 0 6px 10px 6px",
                            boxShadow: "0px 3.11px 3.11px 0px #00000040",
                            background: "#fff",
                            fontWeight: 700,
                            fontSize: 10,
                            color: "#081F2D",
                            textAlign: "center",
                            height: "-webkit-fill-available",
                            fontWeight: "bold",
                            width: "100%",
                            borderRadius: 10,
                            padding: "10px 6px",
                          }}
                        >
                          {challenge.name}
                          <img
                            src={challenge.img}
                            alt={challenge.alt}
                            style={{
                              width: 36,
                              height: 36,
                              objectFit: "contain",
                              marginBottom: 8,
                            }}
                          />
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              width: "100%",
                              flexDirection: "column",
                            }}
                          >
                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: 10,
                                color: "#1693f6",
                              }}
                            >
                              {earnedPoints} Points
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
              {/* Treasure */}
              <div
                className="drawer-list-item"
                onClick={() => handleCollapse("treasure")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 700,
                  fontSize: 16,
                  color: "#0a2a3a",
                  cursor: "pointer",
                  gap: 16,
                  padding: "18px 0",
                }}
              >
                <i className="fas fa-gift"></i>
                <span>TREASURES</span>
                <span
                  style={{ marginLeft: "auto", transition: "transform 0.2s" }}
                >
                  <i
                    className={`fas fa-chevron-down${
                      collapse.treasure ? " fa-rotate-180" : ""
                    }`}
                  ></i>
                </span>
              </div>
              <hr
                style={{
                  border: 0,
                  borderTop: "2px solid #081F2D",
                  margin: "0 !important",
                }}
              />
              {collapse.treasure &&
                (selectedTreasure === null ? (
                  <div
                    className="drawer-expand-content"
                    style={{
                      maxHeight: "32vh",
                      overflowY: "auto",
                      background: "#eaf7fc",
                      padding: "0px 0 8px 0",
                      display: "grid",
                      gridTemplateColumns: "repeat(2, 1fr)",
                      gap: 14,
                      marginTop: 16,
                    }}
                  >
                    {sortedTreasures.map(({ index, unlocked, name }) => {
                      // const cardStyle = {
                      //   background: "#fff",
                      //   borderRadius: 12,
                      //   padding: 6,
                      //   width: "100%",
                      //   aspectRatio: 1 / 0.7,
                      //   position: "relative",
                      //   display: "flex",
                      //   alignItems: "center",
                      //   justifyContent: "center",
                      //   boxSizing: "border-box",
                      //   minHeight: 0,
                      //   boxShadow: "0px 3.11px 3.11px 0px #00000040",
                      //   ...(unlocked ? { cursor: "pointer" } : {}),
                      // };
                      return (
                        <div
                          key={index}
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              fontWeight: 700,
                              fontSize: 12,
                              color: unlocked ? "#081F2D" : "#fff",
                              background: unlocked ? "#fff" : "#081F2DCC",
                              borderRadius: 8,
                              padding: "10px 6px",
                              width: "100%",
                              boxSizing: "border-box",
                              textAlign: "center",
                              // boxShadow: "0px 3.11px 3.11px 0px #00000040",
                            }}
                            onClick={() =>
                              unlocked && setSelectedTreasure(index)
                            }
                          >
                            {unlocked
                              ? name.length > 12
                                ? `${name.substring(0, 12)}...`
                                : name
                              : "🔒 Locked"}
                          </div>
                          {/* <div
                            style={cardStyle}
                            onClick={() =>
                              unlocked && setSelectedTreasure(index)
                            }
                          >
                            {unlocked ? (
                              <div
                                style={{
                                  fontWeight: 600,
                                  fontSize: 14,
                                  color: "#1693f6",
                                }}
                              >
                                Reward
                              </div>
                            ) : (
                              <div
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "100%",
                                  background: "#081F2DCC",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  borderRadius: 12,
                                  zIndex: 2,
                                  margin: 0,
                                }}
                              >
                                <div
                                  style={{
                                    fontSize: 28,
                                    color: "#fff",
                                    marginBottom: 6,
                                  }}
                                >
                                  🔒
                                </div>
                                <div
                                  style={{
                                    fontWeight: 700,
                                    fontSize: 16,
                                    color: "#fff",
                                    letterSpacing: 1,
                                  }}
                                >
                                  Locked
                                </div>
                              </div>
                            )}
                          </div> */}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      background: "#eaf7fc",
                      zIndex: 100,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      overflowY: "auto",
                      padding: 0,
                    }}
                  >
                    <TreasureDetailCard
                      onBack={() => setSelectedTreasure(null)}
                      treasure={
                        selectedTreasure === -1
                          ? firstRewardConfig
                          : currentTreasureData[selectedTreasure] || {}
                      }
                    />
                  </div>
                ))}
            </div>
            <div style={{ flex: 1 }}></div>
            <button
              className="drawer-photo-booth"
              onClick={() => {
                handleDrawerClose();
                setTimeout(() => {
                  navigate("/photobooth");
                }, 300);
              }}
              style={{
                margin: 24,
                marginTop: "auto",
                marginBottom: 16,
                background: "#0096db",
                color: "#fff",
                fontWeight: 700,
                fontSize: 18,
                border: "none",
                borderRadius: 14,
                width: "calc(100% - 48px)",
                height: 54,
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                letterSpacing: 1,
              }}
            >
              TRY PHOTOBOOTH
            </button>
            <div
              style={{
                display: "flex",
                gap: "8px",
                margin: "16px",
                marginTop: 0,
              }}
            >
              <button
                className="drawer-faq"
                onClick={handleHelp}
                style={{
                  flex: 1,
                  background: "transparent",
                  color: "#081F2D",
                  fontWeight: 500,
                  fontSize: 14,
                  border: "none",
                  borderRadius: 0,
                  // height: 48,
                  // textDecoration: "underline",
                  letterSpacing: 0.5,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "6px",
                }}
              >
                FAQ
                <span
                  className="help-icon"
                  style={{ border: "2px solid #081F2D", color: "#081F2D" }}
                >
                  ?
                </span>
              </button>
              <button
                className="drawer-signout"
                onClick={handleSignOut}
                style={{
                  flex: 1,
                  background: "transparent",
                  color: "#081F2D",
                  fontWeight: 700,
                  fontSize: 18,
                  border: "1px solid #000000",
                  borderRadius: 14,
                  height: 48,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  letterSpacing: 1,
                }}
              >
                SIGN OUT
              </button>
            </div>
          </div>
        </div>
      )}

      <FAQModal isOpen={showFAQModal} onClose={() => setShowFAQModal(false)} />
      <LeaderboardModal
        isOpen={showLeaderboardModal}
        onClose={() => setShowLeaderboardModal(false)}
      />
    </>
  );
};

export default Header;
